import { Component, OnInit } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';

interface CurrentUser {
  name: string;
  email: string;
  role: string;
}

@Component({
  selector: 'app-superadmin-dashboard',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './superadmin-dashboard.component.html',
  styleUrl: './superadmin-dashboard.component.css'
})
export class SuperadminDashboardComponent implements OnInit {
  currentUser: CurrentUser | null = null;

  ngOnInit(): void {
    // Get current user from localStorage or service
    const userData = localStorage.getItem('currentUser');
    if (userData) {
      try {
        this.currentUser = JSON.parse(userData);
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }

    // Set default user if none exists
    if (!this.currentUser) {
      this.currentUser = {
        name: 'Super Admin',
        email: 'admin@hector.com',
        role: 'Super Admin'
      };
    }
  }
}
